import axios from "axios";

/**
 * Send the message to the client with their name and link to the form to fill up
 */

export async function SendMessage(name, phone, weblink) {
  try {
    const access_token = process.env.REACT_APP_WHATSAPP_TOKEN;
    const business_account_id =
      process.env.REACT_APP_WHATSAPP_BUSINESS_ACCOUNT_ID;
    const api_version = process.env.REACT_APP_WHATSAPP_API_VERSION;
    const templateName = process.env.REACT_APP_TEMPLATE_NAME;

    const header = {
      headers: {
        Authorization: `Bearer ${access_token}`,
        Accept: "application/json",
      },
    };
    const body = {
      messaging_product: "whatsapp",
      recipient_type: "individual",
      to: `${phone}`,
      type: "template",
      template: {
        name: `${templateName}`,
        language: {
          code: "en_GB",
        },
        components: [
          {
            type: "body",
            parameters: [
              {
                type: "text",
                text: `${name}`,
              },
              {
                type: "text",
                text: `${weblink}`,
              },
            ],
          },
        ],
      },
    };

    const sendMsg = await axios.post(
      `https://graph.facebook.com/${api_version}/${business_account_id}/messages`,
      body,
      header
    );

    return { status: "success", data: sendMsg.data };
  } catch (error) {
    console.log(error);
    return { status: "failed", message: error.message };
  }
}
